import React from "react";
import { DYNAMICS_FIELDS } from "@constants";

import {
    FormMapperApp,
    type FormalizrDynamicsFormData,
    type FormalizrDynamicsGeneralData,
    type FormalizrDynamicsMetaData,
} from "@types";

import { encodeObjectToBase64 } from "@utils/codec";
import { useContextStore } from "@hooks";
import { useLocation } from "@reach/router";

type DynamicsHiddenField = {
    name: string;
    value: string;
    enum: string[] | undefined;
};

type DynamicsFormProps = {
    fields: DynamicsHiddenField[];
    name: string;
    locale: string;
    mapperData: FormMapperApp;
};

const DynamicsForm = ({ fields, name, mapperData }: DynamicsFormProps) => {
    const { href, pathname } = useLocation();

    const { market, language } = useContextStore();
    const generalData: FormalizrDynamicsGeneralData = {
        "form-name": name,
    };

    const metaData: FormalizrDynamicsMetaData = {
        currentPage: href,
        slug: pathname,
        pageOfEntry: "",
        channel: "DPAM",
        previousPage: "",
        market: market,
        lang: language ?? "",
        timeOfSumbit: new Date().toUTCString(),
        anynomousId: "",
        tags: [],
    };

    const formData: FormalizrDynamicsFormData = {};

    fields.forEach(field => {
        if (field.value !== "") {
            formData[field.name] = field.value;
        }
    });

    return (
        <form data-no-submit="true" id={name} name={name}>
            {fields.map(field => {
                const mappedField = mapperData?.data[field.name];

                //Boolean field
                if (mappedField?.type === "boolean") {
                    return (
                        <input
                            aria-hidden
                            checked={!!field.value}
                            key={field.name}
                            name={field.name}
                            style={{ display: "none" }}
                            type="checkbox"
                        />
                    );
                }

                //checkbox group
                if (field.enum) {
                    return (
                        <fieldset key={field.name} name={field.name}>
                            {field.enum?.map((input, ind) => (
                                <input
                                    aria-hidden
                                    key={ind}
                                    name={input}
                                    style={{ display: "none" }}
                                    type="checkbox"
                                    value={mappedField?.enum?.[input]}
                                />
                            ))}
                        </fieldset>
                    );
                }

                return (
                    <input
                        defaultValue={field.value}
                        key={field.name}
                        name={field.name}
                        type="hidden"
                    />
                );
            })}
            <input
                defaultValue={encodeObjectToBase64(metaData)}
                name={DYNAMICS_FIELDS.metaData}
                type="hidden"
            />
            <input
                defaultValue={encodeObjectToBase64(formData)}
                name={DYNAMICS_FIELDS.formData}
                type="hidden"
            />
            <input
                defaultValue={encodeObjectToBase64(generalData)}
                name={DYNAMICS_FIELDS.generalData}
                type="hidden"
            />
        </form>
    );
};

export default DynamicsForm;
